import { Avatar, Divider, Upload, message } from "antd";
import { PageHeader } from "../components";
import { Paper, Chip } from "@mantine/core";
import { useState } from "react";
import { getUser } from "../helpers/auth";
import { useQuery } from "react-query";
import {
  getUserProfile,
  patchDoctorSignatureStamp,
  postStaffSignatureImage,
  postStaffStampImage,
} from "../helpers/api";
import { getUser as getAuthUser } from "../helpers/auth";
import { AttendanceComponent } from "./attendance";
import defaultAvatar from "../static/img/default-avatar.png";


const AVATAR_PLACEHOLDER = defaultAvatar;
const ProfilePage = (props) => {

  const authUser = getAuthUser();
  const role = authUser?.role?.toLowerCase?.();
  const canManageSignatureAndStamp =
    role === "doctor" || role === "superuser";

  const [isSignatureHover, setSignatureHover] = useState(false);
  const [isStampHover, setStampHover] = useState(false);
  const [isUploadingSignature, setIsUploadingSignature] = useState(false);
  const [isDeletingSignature, setIsDeletingSignature] = useState(false);
  const [isUploadingStamp, setIsUploadingStamp] = useState(false);
  const [isDeletingStamp, setIsDeletingStamp] = useState(false);

  const { data: user = {}, refetch } = useQuery({
    queryFn: () => getUserProfile(getUser().id),
    queryKey: ['profile'],
  });


  return (
    <section className="user-profile">
      <PageHeader title="Profile" hasBackButton description="your profile">
      </PageHeader>
      <Divider className="mt-1" />
      <div className="row mt-4">
        <div className="col-md-8 col-12 mx-auto p-4  text-center">
          <Paper className="p-4">
            <div>
              <Avatar
                className="user-avatar"
                size="large"
                src={user?.staff?.avatarUrl || AVATAR_PLACEHOLDER}
              />
            </div>
            <h5 className="mt-3 mb-0">{`${user?.staff?.firstName} ${user?.staff?.lastName}`}</h5>
            <Chip color="primary" disabled size="sm" variant="outline" className="mt-2">
              {user?.role}
            </Chip>
            <div className="mt-3" />

            <p className="mt-2 mb-3">
              {`${user?.email?.slice(0, 1)}${"*".repeat(user?.email?.length / 3) +
                user?.email?.slice(user?.email?.length / 2)
                }`}
            </p>

            <AttendanceComponent />

            {(user?.staff?.signatureUrl ||
              user?.staff?.stampUrl ||
              canManageSignatureAndStamp) && (
                <div className="mt-3">
                  <div className="row justify-content-center">
                    <div
                      className="col-md-5 col-12 mb-3"
                      onMouseEnter={() => setSignatureHover(true)}
                      onMouseLeave={() => setSignatureHover(false)}
                    >
                      <h6 className="mb-2">Signature</h6>
                      <div
                        className="p-3 rounded"
                        style={{
                          backgroundColor: "#f5f5f5",
                          border: "1px solid #d9d9d9",
                          transition: "box-shadow 0.2s, transform 0.2s",
                          boxShadow: isSignatureHover
                            ? "0 2px 6px rgba(0,0,0,0.15)"
                            : "none",
                          transform: isSignatureHover ? "translateY(-2px)" : "none",
                        }}
                      >
                        {user?.staff?.signatureUrl ? (
                          <img
                            src={user.staff.signatureUrl}
                            alt="Doctor signature"
                            style={{
                              maxWidth: "100%",
                              maxHeight: 120,
                              objectFit: "contain",
                              backgroundColor: "white",
                              borderRadius: 4,
                            }}
                          />
                        ) : (
                          <p className="text-muted mb-0">No signature on file</p>
                        )}
                        {canManageSignatureAndStamp && (
                          <div className="mt-2 d-flex justify-content-center gap-2">
                            <Upload
                              accept="image/*"
                              showUploadList={false}
                              customRequest={({ file, onSuccess, onError }) => {
                                setIsUploadingSignature(true);
                                const formData = new FormData();
                                formData.append("file", file);
                                postStaffSignatureImage(user.staff.id, formData)
                                  .then((res) => {
                                    if (res.status === 200) {
                                      message.success("Signature updated");
                                      refetch();
                                    } else {
                                      message.error(
                                        res?.response?.data?.message ||
                                        "Failed to upload signature"
                                      );
                                    }
                                    onSuccess?.(res, new XMLHttpRequest());
                                  })
                                  .catch((e) => {
                                    onError?.(e);
                                  })
                                  .finally(() => {
                                    setIsUploadingSignature(false);
                                  });
                              }}
                            >
                              <button
                                className={`app-btn btn-prim mb-2 btn-sm ${isUploadingSignature ? "is-loading" : ""}`}
                                disabled={isUploadingSignature || isDeletingSignature}
                              >
                                {isUploadingSignature
                                  ? "Uploading..."
                                  : "Upload Signature"}
                              </button>
                            </Upload>
                            {user?.staff?.signatureUrl && (
                              <button
                                className="app-btn btn-danger mb-2 btn-sm"
                                disabled={isUploadingSignature || isDeletingSignature}
                                onClick={async () => {
                                  try {
                                    setIsDeletingSignature(true);
                                    const res = await patchDoctorSignatureStamp(
                                      user.staff.id,
                                      {
                                        signatureUrl: null,
                                      }
                                    );
                                    if (res.status === 200) {
                                      message.success("Signature removed");
                                      refetch();
                                    }
                                  } finally {
                                    setIsDeletingSignature(false);
                                  }
                                }}
                              >
                                {isDeletingSignature ? "Removing..." : "Remove"}
                              </button>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                    <div
                      className="col-md-5 col-12 mb-3"
                      onMouseEnter={() => setStampHover(true)}
                      onMouseLeave={() => setStampHover(false)}
                    >
                      <h6 className="mb-2">Stamp</h6>
                      <div
                        className="p-3 rounded"
                        style={{
                          backgroundColor: "#f5f5f5",
                          border: "1px solid #d9d9d9",
                          transition: "box-shadow 0.2s, transform 0.2s",
                          boxShadow: isStampHover
                            ? "0 2px 6px rgba(0,0,0,0.15)"
                            : "none",
                          transform: isStampHover ? "translateY(-2px)" : "none",
                        }}
                      >
                        {user?.staff?.stampUrl ? (
                          <img
                            src={user.staff.stampUrl}
                            alt="Doctor stamp"
                            style={{
                              maxWidth: "100%",
                              maxHeight: 140,
                              objectFit: "contain",
                              backgroundColor: "white",
                              borderRadius: 4,
                            }}
                          />
                        ) : (
                          <p className="text-muted mb-0">No stamp on file</p>
                        )}
                        {canManageSignatureAndStamp && (
                          <div className="mt-2 d-flex justify-content-center gap-2">
                            <Upload
                              accept="image/*"
                              showUploadList={false}
                              customRequest={({ file, onSuccess, onError }) => {
                                setIsUploadingStamp(true);
                                const formData = new FormData();
                                formData.append("file", file);
                                postStaffStampImage(user.staff.id, formData)
                                  .then((res) => {
                                    if (res.status === 200) {
                                      message.success("Stamp updated");
                                      refetch();
                                    } else {
                                      message.error(
                                        res?.response?.data?.message ||
                                        "Failed to upload stamp"
                                      );
                                    }
                                    onSuccess?.(res, new XMLHttpRequest());
                                  })
                                  .catch((e) => {
                                    onError?.(e);
                                  })
                                  .finally(() => {
                                    setIsUploadingStamp(false);
                                  });
                              }}
                            >
                              <button
                                className={`app-btn btn-prim mb-2 btn-sm ${isUploadingStamp ? "is-loading" : ""}`}
                                disabled={isUploadingStamp || isDeletingStamp}
                              >
                                {isUploadingStamp ? "Uploading..." : "Upload Stamp"}
                              </button>
                            </Upload>
                            {user?.staff?.stampUrl && (
                              <button
                                className="app-btn btn-danger mb-2 btn-sm"
                                disabled={isUploadingStamp || isDeletingStamp}
                                onClick={async () => {
                                  try {
                                    setIsDeletingStamp(true);
                                    const res = await patchDoctorSignatureStamp(
                                      user.staff.id,
                                      {
                                        stampUrl: null,
                                      }
                                    );
                                    if (res.status === 200) {
                                      message.success("Stamp removed");
                                      refetch();
                                    }
                                  } finally {
                                    setIsDeletingStamp(false);
                                  }
                                }}
                              >
                                {isDeletingStamp ? "Removing..." : "Remove"}
                              </button>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
          </Paper>
        </div>
      </div>
    </section>
  );
};

export { ProfilePage };
